import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mx-3"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "d-flex flex-row nowrap" }
const _hoisted_4 = { class: "me-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import {
	watch,
	ref,
	Ref,
	nextTick,
	computed,
} from "vue"
import displayPrice from "@/displayPrice/displayPrice"


// content
interface Props {
	selected: number
	open: boolean
	totalAvailable: number
	speed: number
	maximum: number
	locale: string
	accommodationOnly: string | undefined
}


export default /*@__PURE__*/_defineComponent({
  __name: 'hebergementDropdownV2',
  props: {
    selected: { default: 1 },
    open: { type: Boolean, default: false },
    totalAvailable: { default: 1 },
    speed: { default: 100 },
    maximum: { default: 20 },
    locale: {},
    accommodationOnly: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const content = window.content

// Props
const props = __props

// Template refs
const dropdown: Ref<HTMLDivElement | null> = ref(null)

// Emits
const emit = __emit

const handleClick = (newSelected: number): void => {
	emit("select", newSelected)
}

const fadeIn = (display = "block"): void => {
	if (!dropdown.value) return

	const value = dropdown.value
	value.style.display = display

	nextTick(() => {
		value.style.opacity = "1"
	})
}
const fadeOut = (): void => {
	if (!dropdown.value) return
	const value = dropdown.value

	value.style.opacity = "0"
	setTimeout(() => {
		value.style.display = "none"
	}, props.speed)
}

const checkIsSelected = (index: number): boolean => {
	return index === props.selected
}

const accommodationCalculationWithCurrency = computed(() => (option: number) => {
	if (!props.accommodationOnly) return ''
	return displayPrice(parseInt(props.accommodationOnly)*(option-1)*100, props.locale);
})

// Watchers
watch(
	() => props.open,
	(newVal, oldVal) => {
		if (newVal && !oldVal) {
			fadeIn()
		} else if (!newVal && oldVal) {
			fadeOut()
		}
	}
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdown",
    ref: dropdown,
    class: "w-100 hebergement-dropdown py-3 px-4",
    onClick: _withModifiers(() => {}, ["stop"])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalAvailable, (option) => {
      return (_openBlock(), _createElementBlock("div", { key: option }, [
        (option <= _ctx.maximum)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (option !== 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                onClick: _withModifiers(() => handleClick(option), ["stop"]),
                class: "cursor-pointer col-12 d-flex flex-row justify-content-start px-0 m-3 align-items-center hebergement-row-container"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([checkIsSelected(option) && 'active', "hebergement-row-checkbox me-2 ts-form-check-input border-primary-blue mb-1"])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["body text-start", checkIsSelected(option) && 'body-strong text-primary-blue'])
                }, [
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(option), 1),
                    (option === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(content).planningResult_hebergement), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          (_ctx.accommodationOnly)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(content).planningResult_hebergements_abbreviated) + " (+ " + _toDisplayString(accommodationCalculationWithCurrency.value(option)) + ") ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(content).planningResult_hebergements), 1)
                              ], 64))
                        ]))
                  ])
                ], 2)
              ], 8, _hoisted_2)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 512))
}
}

})